import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

document.addEventListener("DOMContentLoaded", () => {
  document.fonts.ready.then(() => {
    const titles = document.querySelectorAll("[text-slide-up]");

    titles.forEach((title) => {
      // SplitText avec autoSplit, lignes et mots
      const split = SplitText.create(title, {
        type: "words, lines",
        linesClass: "line",
        autoSplit: true,
        mask: "lines"
      });

      // Animation sur les lignes ou les mots
      gsap.from(split.words, {
        yPercent: 100,
        opacity: 0,
        duration: 1,
        ease: "expo.out",
        stagger: 0.05,
        scrollTrigger: {
          trigger: title,
          start: "top 90%",
          toggleActions: "play none none none",
          onEnter: () => title.classList.add("animate-underline"),
        }
      });
    });
  });
});
